import { Component } from '@angular/core';
import { TenantService } from '../services/tenant.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    template: `
        <mat-card>
            <mat-card-title><h2 fxFlex>Create Source</h2></mat-card-title>
            <mat-card-content>
                <mat-grid-list cols="3" rowHeight="200px">
                    <mat-grid-tile *ngFor="let sourceType of sourceTypes" fxLayoutAlign="center center">
                        <mat-card style="width: 220px;">
                            <mat-card-content>
                                <div fxLayout="row">
                                    <div>
                                        <img *ngIf="sourceType.imageUrl" 
                                            [src]="sourceType.imageUrl" 
                                            style="height: 35px;">
                                        <mat-icon *ngIf="sourceType.icon" 
                                                fontSet="fontawesome" 
                                                [fontIcon]="sourceType.icon" 
                                                style="font-size: 40px; height: 45px; width: 45px;"></mat-icon>
                                         <mat-icon *ngIf="sourceType.fabIcon"
                                                fontSet="fab"
                                                [fontIcon]="sourceType.fabIcon"
                                                style="font-size: 40px; height: 45px; width: 45px;"></mat-icon>
                                    </div>
                                    <div fxFlex fxLayoutAlign="center center">
                                        <h4 style="margin-top: 10px;">{{sourceType.label}}</h4>
                                    </div>
                                </div>
                            </mat-card-content>
                            <mat-card-actions>
                                <button mat-raised-button 
                                        color="primary"
                                        [routerLink]="[sourceType.type]">Start</button>
                            </mat-card-actions>
                        </mat-card>
                    </mat-grid-tile>
                </mat-grid-list>
            </mat-card-content>
        </mat-card>
    `
})
export class StartCreateSourceComponent {
    allSourceTypes = [
        { label: 'RSS Feed', icon: 'fa-rss', type: 'RSS'}, 
        // { label: 'Search Attensa', icon: 'fa-search', type: 'ATTENSA_SEARCH' },
        { label: 'Import OPML File', icon: 'fa-code', type: 'OPML', enabledByType: 'RSS'},
        { label: 'Twitter Search', fabIcon: 'fa-twitter', type: 'TWITTER_SEARCH' },
        { label: 'Bing Search', fabIcon: 'fa-windows', type: 'BING_SEARCH' },
        { label: 'PubMed Search', imageUrl: '/images/pubmed.gif', type: 'PUBMED_SEARCH' },
        { label: 'ClinicalTrials.gov Search', icon: 'fa-user-md', type: 'CLINICALTRIALS_SEARCH' },
        { label: 'Factiva Select', imageUrl: '/images/factiva.png', type: 'FACTIVA_SELECT_HTTP' },
        { label: 'Scopus Search', icon: 'fa-share-alt', type: 'SCOPUS_SEARCH' },
        { label: 'Diffbot Knowledge Graph', icon: 'fa-search', type: 'DIFFBOT_SEARCH' }
    ];
    sourceTypes = [];

    constructor(private route: ActivatedRoute, private tenantService: TenantService) {
        const data = this.route.snapshot.data
        
        if (data?.isCatalog) {
            this.sourceTypes = this.allSourceTypes.filter(sourceType => sourceType.type !== 'OPML');
        } else {
            this.tenantService.getCurrentTenant()
            .subscribe(tenant => {
                const allowedSources = tenant.settings.allowedSources;
                const allSources = !(tenant.settings.allowedSources && tenant.settings.allowedSources.length);
                this.sourceTypes = this.allSourceTypes.filter(sourceType => {
                    return allSources || allowedSources.includes(sourceType.enabledByType || sourceType.type)
                });
            });
        }
    }
}
